import React from "react";

import spinner from "assets/graphics/icons/spinner.svg";

import "features/application/loader/component/view.scss";

const LoaderView = () => (
  <div className="loader__overlay">
    <img
      className="loader__spinner"
      src={spinner}
      alt="spinner"
      onDragStart={(event) => event.preventDefault()}
    />
  </div>
);

export default LoaderView;
